import { MessageBar } from '@fluentui/react-components'
import { useEffect, useState } from 'react'
import { useSystemMessage } from '../../../../fetchData/queries/settings/useSystemMessage'

export const SystemBar = () => {
  const systemMessage = useSystemMessage().data
  const message = systemMessage?.message
  const type = systemMessage?.type

  const [showSystemMessage, setShowSystemMessage] = useState<boolean>(true)

  useEffect(() => {
    if (message && message?.length > 0) {
      setShowSystemMessage(true)
    } else {
      setShowSystemMessage(false)
    }
  }, [message])

  const messageBarIntent = () => {
    switch (type) {
      case 1:
        return 'warning'
      case 2:
        return 'error'
      default:
        return 'info'
    }
  }

  if (showSystemMessage && message) {
    return <MessageBar intent={messageBarIntent()}>{message}</MessageBar>
  }

  return null
}
